import React from 'react';

function LastVisitedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-566 -1744)">
          <g transform="translate(531 1575)">
            <g transform="translate(35 169)">
              <path d="M19.425 7.458c-.263-.131-1.313-.393-2.888-.785-1.575-.393-1.575-.393-3.28-.654V1.177c0-.393-.132-.653-.395-.785C12.6.131 12.337 0 12.075 0s-.525.13-.788.261C9.581 1.308 7.612 2.617 5.775 4.318c-1.838 1.57-3.15 2.747-3.938 3.663a27.441 27.441 0 01-1.575 1.7c-.13.263-.262.524-.262.786s.131.523.262.786c.263.261.788.915 1.575 1.7.788.916 2.1 2.093 3.938 3.795 1.837 1.57 3.937 2.878 5.512 4.055.394.263.788.263 1.182 0 .393-.261.525-.523.525-1.046v-4.972c1.706-.262 1.837-.262 3.412-.654s2.494-.655 2.888-.786C20.475 12.823 21 11.776 21 10.468c0-1.44-.525-2.355-1.575-3.01z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default LastVisitedIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/LastVisited.js